export const GROUP_MEMBER_BASE_PROPERTY_NAME = 'group_member';
